const ERROR_TAG = "small";
const ERROR_CLASS = "form__error";
const GROUP_ERROR_CLASS = "form__error--group";

const isGroupValid = (group: Element): boolean =>
  Array.from(group.querySelectorAll<HTMLInputElement>("input")).some(
    (input) => input.value.trim() !== ""
  );

const clearGroupError = (group: Element) => {
  group.parentElement
    ?.querySelector(`${ERROR_TAG}.${GROUP_ERROR_CLASS}`)
    ?.remove();
  group
    .querySelectorAll("input")
    .forEach((input) => input.classList.remove(ERROR_CLASS));
};

const showGroupError = (group: Element) => {
  if (group.parentElement?.querySelector(`${ERROR_TAG}.${GROUP_ERROR_CLASS}`)) {
    return;
  }

  const msg = document.getElementById('translations')?.dataset["atLeastOneOfMsg"] ??
    "Bitte füllen Sie mindestens eines der Felder aus.";

  const errorEl = document.createElement(ERROR_TAG);
  errorEl.classList.add(ERROR_CLASS, GROUP_ERROR_CLASS);
  errorEl.innerText = msg;
  group.after(errorEl);

  group
    .querySelectorAll("input")
    .forEach((input) => input.classList.add(ERROR_CLASS));
};

const validateGroup = (group: Element) => {
  if (isGroupValid(group)) {
    clearGroupError(group);
  } else {
    showGroupError(group);
  }
};

const installAtLeastOneOfValidation = (group: Element) => {
  group.addEventListener("focusout", (e: Event) => {
    const relatedTarget = (e as FocusEvent).relatedTarget as Node | null;
    if (!relatedTarget || !group.contains(relatedTarget)) {
      validateGroup(group);
    }
  });

  group.querySelectorAll("input").forEach((input) => {
    input.addEventListener("input", () => {
      if (isGroupValid(group)) {
        clearGroupError(group);
      }
    });
  });

  const form = group.closest("form");
  form?.addEventListener("submit", (e: Event) => {
    if (!isGroupValid(group)) {
      e.preventDefault();
      showGroupError(group);
    }
  });
};

function InitContactForm() {
  // Open the contact form popup
  document.querySelectorAll('.popup-opener').forEach(trigger => {
    trigger.addEventListener('click', (e: Event) => {
      const contactFormPopup = document.querySelector('.contact-form__popup')
      contactFormPopup?.classList.add('contact-form__popup--open')
      contactFormPopup?.classList.remove('contact-form__popup--closed')
    })
  })

  // Close the contact form popup
  document.querySelectorAll('.contact-form__popup-close-icon').forEach(closeIcon =>
    closeIcon.addEventListener('click', (e: Event) => {
      document.querySelectorAll('.contact-form__popup').forEach(contactFormPopup => {
        contactFormPopup.classList.remove('contact-form__popup--open')
        contactFormPopup.classList.add('contact-form__popup--closed')
      })
    })
  )

  document.querySelectorAll(".contact-row--variant-2").forEach(installAtLeastOneOfValidation);
}

InitContactForm()
